import { render, staticRenderFns } from "./CQtTermsCondtions.vue?vue&type=template&id=044deee4&scoped=true"
import script from "./CQtTermsCondtions.vue?vue&type=script&lang=ts"
export * from "./CQtTermsCondtions.vue?vue&type=script&lang=ts"
import style0 from "./CQtTermsCondtions.vue?vue&type=style&index=0&id=044deee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044deee4",
  null
  
)

export default component.exports